import React, { useState } from 'react'
import SelectIcon from './SelectIcon'
import Button from 'components/Button'
import SearchInput from 'components/SearchInput'
import {
  TableCount,
  SearchWidth,
  EmptyElement,
  AlertTextDivNew,
  NoteMessageDivNew,
  StyledSpaceDiv,
} from '../style'
import { TableTop } from 'components/UIComponents/TableSearchFilter/Style/style'
import {
  EmptyWrapper,
  RowNumberData,
  SpanDescription,
} from '../../../ATS/Components/IndividualTable/Style'
import { StyledTableSqare } from '../../../ATS/Components/IndividualTable/TableStyle'
import AntdAvatar from 'components/Avatar'
import { Empty, Spin, Tooltip } from 'antd'
import NoInterview from 'components/icons/NoInterview.png'
import Pagination from 'components/Pagination'
import { TableEllipse } from '../../../Placement/style'
import DriveStatus from './Status'
import Drawer from 'components/Drawer'
import ViewResumeDrawer from 'modules/JobPreview/ViewResumeDrawer/index.js'

const Table = ({
  currentTab,
  handleResolveConflict,
  tableData,
  handlePageChange,
  pageNumber,
  tableLoader,
  handleSearch,
  searchValue,
  setSearchValue,
  handleSorting,
  handleRowSelection,
  conflictData,
  handleStatusClick,
  selectedCandidateId,
  isPaid,
  setIsPaid,
  selectedCandidate,
  setSelectedCandidate,
  setSelectedCandidateId,
  setIsAllSelected,
  isAllSelected,
  wholeSelect,
  setWholeSelect,
  getPreview,
  getEventId,
  setPageNumber,
}) => {
  const [resumeLoading, setResumeLoading] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [viewStudent, setViewStudent] = useState(false)
  const [data, setData] = useState({})

  const columns = [
    {
      width: 180,
      title: <div style={{ width: '90%' }}>Status</div>,
      dataIndex: 'status',
      key: 'status',
      // sorter: true,
      fixed: 'left',
      // sortDirections: ['ascend', 'descend'],
      render: (_, data, index) => {
        return (
          <div>
            <div>
              <DriveStatus
                status={
                  data?.studentEventMapping?.length > 0
                    ? data?.studentEventMapping?.[0]?.isPaid
                    : getEventId?.isRegister === true
                    ? 'Not Registered'
                    : 'INVITED'
                }
                amount={getEventId?.registerAmount}
              />
            </div>
          </div>
        )
      },
    },

    {
      width: 180,
      title: 'Name',
      dataIndex: 'firstName',
      fixed: 'left',
      key: 'firstName',
      //   sortDirections: ['ascend', 'descend'],
      render: (_, candidateData) => {
        let name = candidateData?.firstName + ' ' + candidateData?.lastName

        return (
          <div style={{ display: 'flex', gap: '10px' }}>
            <div
              style={{
                width: '35px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <AntdAvatar
                style={{
                  // backgroundColor: 'transparent',
                  verticalAlign: 'middle',
                }}
                src={candidateData?.profileUrl}
                IconName={candidateData?.firstName?.split('')[0]?.toUpperCase()}
                padding={candidateData?.profileUrl ? '0px' : '8px'}
                // size={35}
              ></AntdAvatar>
            </div>
            <div style={{ width: 'calc(95% - 35px)' }}>
              <Tooltip title={`${name}`}>
                <TableEllipse
                  onClick={() => handleNameClick(candidateData)}
                  style={{
                    color: 'rgba(50, 73, 215, 1)',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                  }}
                >
                  {name}
                </TableEllipse>
                <p style={{ color: '#bfbfbf', margin: '0px' }}>
                  {candidateData?.uniRollNo ?? '-'}
                </p>
              </Tooltip>
            </div>
          </div>
        )
      },
    },

    {
      title: 'Degree & Department',
      dataIndex: 'stage',
      sorter: true,
      key: 'degree',
      width: 180,
      sortDirections: ['ascend', 'descend'],
      render: (_, student) => (
        <RowNumberData>
          <div
            style={{
              width: '90%',
            }}
          >
            <div style={{ fontWeight: '500' }}>
              {student?.currentCourse?.degree ?? '-'}
            </div>
            <Tooltip title={student?.currentCourse?.department}>
              <div
                style={{
                  textWrap: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  textTransform: 'initial',
                  fontWeight: '500',
                }}
              >
                {student?.currentCourse?.department}
              </div>
            </Tooltip>
          </div>
        </RowNumberData>
      ),
    },

    {
      width: 180,
      title: 'Contact details ',
      dataIndex: 'instituteCampusName',
      key: 'instituteCampusName',
      //   sortDirections: ['ascend', 'descend'],
      render: (_, student) => (
        <RowNumberData>
          <div
            style={{
              width: '90%',
            }}
          >
            <div style={{ fontWeight: '500' }}>
              {student?.studentPersonalProfile?.phoneNumber ?? '-'}
            </div>
            <Tooltip title={student?.studentPersonalProfile?.primaryEmail}>
              <div
                style={{
                  textWrap: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  textTransform: 'initial',
                  fontWeight: '500',
                }}
              >
                {student?.studentPersonalProfile?.primaryEmail}
              </div>
            </Tooltip>
          </div>
        </RowNumberData>
      ),
    },
  ]

  const handleNameClick = async data => {
    try {
      setIsLoading(true)

      await fetchPreviewData(data?.id)
    } catch (error) {
      console.error(error)
    }
  }
  const fetchPreviewData = async id => {
    try {
      setResumeLoading(true)
      const response = await getPreview(id)
      setResumeLoading(false)

      setViewStudent(true)
      setData(response)
      setIsLoading(false)
    } catch (error) {
      console.error('Error fetching preview data:', error)
    } finally {
      setResumeLoading(false)
    }
  }

  const content = () => {
    return resumeLoading ? (
      <Spin
        tip="Loading"
        size="small"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '50vh',
        }}
      />
    ) : (
      <ViewResumeDrawer
        viewDrawer={viewStudent}
        setViewDrawer={setViewStudent}
        previewData={data}
        setIsLoading={setIsLoading}
        isLoading={isLoading}
      />
    )
  }

  const handleClose = () => {
    setViewStudent(false)
    setData('')
  }
  const handleSelectAllClick = () => {
    setIsAllSelected(true)
  }

  const handleClearAllClick = () => {
    setIsAllSelected(false)
    setSelectedCandidateId([])
    setSelectedCandidate([])
  }

  return (
    <>
      {getEventId?.registerAmount > 0 && (
        <div
          style={{
            display: 'flex',

            height: '5em',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            background: 'white',
            margin: '0px 10px',
          }}
        >
          <SelectIcon
            currentTab={currentTab}
            isPaid={isPaid}
            handleStatusClick={handleStatusClick}
            selectedCandidateId={selectedCandidateId}
            setIsPaid={setIsPaid}
            setPageNumber={setPageNumber}
          />
          <Button.Danger
            wordBreak
            text={'Resolve Conflicts'}
            onClick={() => handleResolveConflict()}
            disable={conflictData?.result?.length === 0}
          />
        </div>
      )}
      <TableTop
        centerVertically
        style={{ paddingTop: '0px' }}
        customHeight={'3rem'}
      >
        <SearchWidth>
          <SearchInput
            width={'80%'}
            placeholder={'Search By Keyword'}
            bordered={false}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            handleSearch={handleSearch}
          />
        </SearchWidth>
        <TableCount>
          Showing {pageNumber * 10 + tableData?.result?.length} of{' '}
          {tableData?.count}
        </TableCount>
      </TableTop>
      {wholeSelect &&
        selectedCandidate?.length !== 0 &&
        tableData?.totalPage > 1 && (
          <div
            style={{
              display: 'flex',
              wordSpacing: '2px',
              paddingTop: '10px',
            }}
          >
            <div style={{ fontSize: '13px', paddingTop: '10px' }}>
              {}
              {!isAllSelected ? (
                <>
                  {`Selected `}
                  <span style={{ fontWeight: 800 }}>
                    {`${selectedCandidate?.length} ${
                      selectedCandidate?.length > 1 ? 'candidates' : 'candidate'
                    }`}
                  </span>
                  {` from this pages.`}
                </>
              ) : (
                <>
                  <span style={{ fontWeight: 800 }}>
                    {`${tableData?.count}`}
                    {` candidates `}
                  </span>
                  {`from all pages.`}
                </>
              )}
            </div>
            <NoteMessageDivNew mandatory={true}>
              <StyledSpaceDiv mandatory={true}>
                <AlertTextDivNew mandatory={true}>
                  {!isAllSelected ? (
                    <span>
                      <EmptyElement
                        style={{
                          paddingLeft: '3px',
                          paddingRight: '3px',
                          wordSpacing: '2px',
                          cursor: 'pointer',
                        }}
                        onClick={handleSelectAllClick}
                      >
                        {`Select all `}
                        <span style={{ fontWeight: 800 }}>
                          {`${tableData?.count} ${
                            tableData?.count > 1 ? 'candidates' : 'candidate'
                          }`}
                        </span>
                        {` from all pages.`}
                      </EmptyElement>
                    </span>
                  ) : (
                    <span>
                      <EmptyElement
                        style={{
                          fontWeight: '800',
                          paddingLeft: '3px',
                          paddingRight: '3px',
                          wordSpacing: '2px',
                          cursor: 'pointer',
                        }}
                        onClick={handleClearAllClick}
                      >
                        {`Clear Selection`}
                      </EmptyElement>
                    </span>
                  )}
                </AlertTextDivNew>
              </StyledSpaceDiv>
            </NoteMessageDivNew>
          </div>
        )}
      <StyledTableSqare
        rowSelection={currentTab == 'REGISTER' ? handleRowSelection : ''}
        rowKey={record => record?.id}
        columns={columns}
        dataSource={tableData?.result}
        pagination={false}
        onChange={handleSorting}
        scroll={{
          x: 1000,
        }}
        className={'drivetable-table'}
        bordered
        locale={{
          emptyText: (
            <EmptyWrapper column alignCenter>
              {tableLoader ? (
                <Spin />
              ) : (
                <Empty
                  image={NoInterview}
                  imageStyle={{ height: 300 }}
                  description={
                    <SpanDescription>No data available</SpanDescription>
                  }
                />
              )}
            </EmptyWrapper>
          ),
        }}
      />
      {tableData?.result?.length > 0 && (
        <Pagination
          onChange={handlePageChange}
          totalPages={tableData?.totalPage * 10}
          pageSize={10}
          current={pageNumber + 1}
        />
      )}
      <Drawer
        width="80%"
        title={' '}
        placement="right"
        closable={true}
        visible={viewStudent}
        content={content()}
        overflowBody={'hidden'}
        onClose={() => handleClose()}
      />
    </>
  )
}
export default Table
